var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-c"},[_c('div',{staticClass:"save",on:{"click":function($event){return _vm.toShare('save')}}},[_vm._v("长按图片保存")]),_vm._v(" "),_c('div',{staticClass:"cancel",on:{"click":_vm.handleCancle}},[_vm._v("取消")])])}
var staticRenderFns = []

export { render, staticRenderFns }